import reducer from './reducers'

// export { default as genderOperations } from './operations';
export { default as comaticSelector } from './selectors'
// export { TypeKeys as genderConstants } from './constants';
// export { ComaticState } from './types'

export default reducer
